import {useMatchMedia} from 'jsxstyle'

export function useMediaQuery(query: string) {
  return useMatchMedia(query)
}

export function useResponsiveBreakpoints(): {
  /**
   * Commonly known as:
   * - 'sm' breakpoint
   * - @media (min-width: 640px)
   */
  tablet: boolean
  /**
   * Commonly known as:
   * - 'md' breakpoint
   * - @media (min-width: 768px)
   */
  wideTablet: boolean
  /**
   * Commonly known as:
   * - 'lg' breakpoint
   * - @media (min-width: 1024px)
   */
  laptop: boolean
  /**
   * Commonly known as:
   * - 'xl' breakpoint
   * - @media (min-width: 1280px)
   */
  desktop: boolean
  /**
   * Commonly known as:
   * - '2xl' breakpoint
   * - @media (min-width: 1536px)
   */
  wideDesktop: boolean
} {
  const tablet = useMediaQuery('(min-width: 640px)')
  const wideTablet = useMediaQuery('(min-width: 768px)')
  const laptop = useMediaQuery('(min-width: 1024px)')
  const desktop = useMediaQuery('(min-width: 1280px)')
  const wideDesktop = useMediaQuery('(min-width: 1536px)')

  return {tablet, wideTablet, laptop, desktop, wideDesktop}
}

export function useDeviceType(): 'mobile' | 'tablet' | 'wideTablet' | 'laptop' | 'desktop' | 'wideDesktop' {
  const {tablet, wideTablet, laptop, desktop, wideDesktop} = useResponsiveBreakpoints()

  if (wideDesktop) return 'wideDesktop'
  if (desktop) return 'desktop'
  if (laptop) return 'laptop'
  if (wideTablet) return 'wideTablet'
  if (tablet) return 'tablet'
  return 'mobile'
}
